export default function (person) {
    if (!person.lastName) {
        return person.firstName;
    }

    return `${person.firstName} ${person.lastName}`;
}
